module.exports = __webpack_public_path__ + "img/icos1.f519dc70.svg";